import type {Intent} from '../intent';
import {forceApplyThemesIntent} from './intent';

/**
 * Applies themes in order even under `themePolicy="allow-forced-only"`. The
 * exemption belongs to these applications, including their composed themes,
 * rather than to the shared theme objects or to the descendant React subtree.
 * It does not bypass `themePolicy="block-all"`.
 */
export function forceApplyThemes(themes: Intent[]): Intent {
  return forceApplyThemesIntent(themes);
}
